import useSocketReconnect from '../../utils/useSocketReconnect';
import { useEffect, useState } from "react";
import moment from 'moment';
import { fetchAPI } from "../../utils/utils";

function Event({ socket, event, selectEvent, isSelected, subgroupName, forms }) {
    useSocketReconnect(socket, () => {
        if (event?.id) socket.emit('.request_form_responses', event.id);
    });

    const [assistencies, setAssistencies] = useState([]);
    const [responses, setResponses] = useState([]);

    useEffect(() => {
        if (event?.id) fetchAPI(`/assistencies_event/${event.id}`, data => setAssistencies(data.data))

        socket.emit('.request_form_responses', event?.id)

        const onFormResponses = (res) => {
            if (res.evId === event?.id) {
                // setResponses(Object.values(res.responses))
                setResponses(Object.keys(res.responses))
            }
        }
        socket.on('.form_responses', onFormResponses)

        return () => {
            socket.off('.form_responses', onFormResponses);
        }
    }, [event]);

    const no_confirmats = assistencies
        .filter(row => row.assistencia === subgroupName);

    const thereIsAForm = event?.id && forms && event.id in forms;

    const nonRespondants = thereIsAForm ? assistencies
        .filter(row => row.assistencia !== 'No vinc')
        .filter(row => !responses.map(id => parseInt(id)).includes(row.id)) :
        []

    const formattedDate = event && moment(event['data-esperada-inici'])
        .format('DD/MM HH:mm')

    const subgroupOptions = {
        'No confirmat': {
            color: 'orange',
            emoji: '😶'
        },
        'Vinc': {
            color: 'green',
            emoji: '✅'
        },
        'No vinc': {
            color: 'red',
            emoji: '❌'
        },
        'Formulari no respost': {
            color: 'gray',
            emoji: '📝'
        }
    }

    return (
        <div
            className={`notifications-event-item ${!event ? 'notifications-event-item-empty' : ''} ${isSelected ? 'notifications-event-item-active' : ''}`}
            onClick={() => event ? selectEvent(event) : selectEvent()}
        >
            <div><strong>{ event?.id in forms ? '(📝) ' : '' }{event ? event.title : 'No triar cap esdeveniment'}</strong></div>
            { event && <div>{formattedDate}</div> }
            { event && <div><span style={{ color: subgroupOptions[subgroupName].color }}>{subgroupOptions[subgroupName].emoji} {subgroupName === 'Formulari no respost' && !thereIsAForm ? '-' : (subgroupName !== 'Formulari no respost' ? no_confirmats : nonRespondants).filter(info => !!info.has_notifications).length}</span> + 🔕 <span style={{ color: 'red' }}>{subgroupName === 'Formulari no respost' && !thereIsAForm ? '-' : (subgroupName !== 'Formulari no respost' ? no_confirmats : nonRespondants).filter(info => !info.has_notifications).length}</span></div> }
        </div>
    )
}

export const dateId = d => [d.getDate(), d.getMonth(), d.getFullYear()].join('-');

function ChooseEvent({ forms, socket, selectedEvent, setSelectedEvent, setSelectedDay, events, setEvents, subgroupName }) {
    useSocketReconnect(socket, () => {
        socket.emit('.request_calendar');
    });

    const PAGE_SIZE = 10;
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

    useEffect(() => {
        socket.emit('.request_calendar');
        const onCalendarEvents = () => socket.emit(`.request_all_events`);
        const onEvents = data => setEvents(data);
        socket.on('.calendar_events', onCalendarEvents);
        socket.on(`.events`, onEvents);
        return () => {
            socket.off(`.events`, onEvents);
            socket.off('.calendar_events', onCalendarEvents);
        }
    }, []);

    useEffect(() => {
        setVisibleCount(PAGE_SIZE);
    }, [events]);

    // Select event from URL
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const eventFromURL = urlParams.get('ev');
        if (!eventFromURL) return;
    
        const eventInfo = events.find(event => event.id === parseInt(eventFromURL));
        if (eventInfo) {
            setSelectedEvent(parseInt(eventFromURL));
            const dayId = dateId(new Date(eventInfo['data-esperada-inici']))
            setSelectedDay(dayId);
        }
    }, [
        events,
    ])

    const beforeNow = dateString => (new Date(new Date(dateString).toLocaleString("en-US", {timeZone: 'UTC'}))) <= (new Date());
    const afterNow = dateString => (new Date()) <= (new Date(new Date(dateString).toLocaleString("en-US", {timeZone: 'UTC'})));

    const futureEvents = events
        .sort((a, b) => new Date(a['data-esperada-inici']) > new Date(b['data-esperada-inici']) ? 1 : -1)
        .filter(event => afterNow(event["data-esperada-fi"]))

    const selectedEventIndex = futureEvents.findIndex(event => event.id === selectedEvent);

    useEffect(() => {
        if (selectedEventIndex === -1) return;

        setVisibleCount(prev => {
            if (selectedEventIndex + 1 <= prev) return prev;

            const required = Math.ceil((selectedEventIndex + 1) / PAGE_SIZE) * PAGE_SIZE;
            return Math.max(prev, required);
        });
    }, [selectedEventIndex]);

    const none_event = <Event
        key={-1}
        isSelected={
            futureEvents.every(event => event.id !== selectedEvent)
        }
        selectEvent={() => {
            setSelectedEvent(null);
            setSelectedDay(null);
        }}
        socket={socket}
        subgroupName={subgroupName}
        forms={forms}
    />

    const visibleEvents = futureEvents.slice(0, visibleCount);

    const llista_events = visibleEvents.map(event =>
        <Event
            key={event.id}
            event={event}
            isSelected={selectedEvent === event.id}
            selectEvent={ev => {
                setSelectedEvent(ev.id);
                const dayId = dateId(new Date(ev['data-esperada-inici']))
                setSelectedDay(dayId);
            }}
            socket={socket}
            subgroupName={subgroupName}
            forms={forms}
        />
    )

    const loadMoreButton = futureEvents.length > visibleCount ? (
        <div className="notifications-event-item notifications-event-load-more">
            <button
                onClick={() => setVisibleCount(prev => prev + PAGE_SIZE)}
            >
                Carrega més esdeveniments
            </button>
        </div>
    ) : null;

    return (
        <div className="notifications-event-list">
            {[none_event, ...llista_events, loadMoreButton]}
        </div>
    )
}

export default ChooseEvent;
